import Vue from 'vue'
import Router from 'vue-router'
import About from './views/About.vue'
import Contact from './views/Contact.vue'
import Work from './views/Work.vue'
import WorkPost from './views/WorkPost.vue'
import Credits from './views/Credits.vue'
import Sitemap from './views/Sitemap.vue'
import Privacy from './views/Privacy.vue'
import Error from './views/Error.vue'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'about',
    component: About,
    meta: {
      title: 'Nathan Lecompte — Programmer, designer and tech enthusiast.',
      metaTags: [
        {
          name: 'description',
          content: 'This is the personal website of Nathan Lecompte; a programmer, designer and tech enthusiast currently working in Sydney, Australia.'
        },
        {
          name: 'keywords',
          content: 'nathan,lecompte,natlec,tech,enthusiast,programmer,developer,designer,work,student,development,website,functionality,creativity,security,application,management,design'
        },
        {
          property: 'og:title',
          content: 'About — Nathan Lecompte'
        },
        {
          property: 'og:description',
          content: 'This is the personal website of Nathan Lecompte; a programmer, designer and tech enthusiast currently working in Sydney, Australia.'
        }
      ]
    }
  },
  {
    path: '/about',
    redirect: '/'
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: {
      title: 'Contact — Nathan Lecompte',
      metaTags: [
        {
          name: 'description',
          content: 'Contact Nathan Lecompte via email or various other platforms; additionally, encrypt your message with PGP.'
        },
        {
          name: 'keywords',
          content: 'nathan,lecompte,natlec,tech,enthusiast,programmer,developer,designer,contact,email,communicate,message,PGP,encrypted'
        },
        {
          property: 'og:title',
          content: 'Contact — Nathan Lecompte'
        },
        {
          property: 'og:description',
          content: 'Contact Nathan Lecompte via email or various other platforms; additionally, encrypt your message with PGP.'
        }
      ]
    }
  },
  {
    path: '/work',
    name: 'work',
    component: Work,
    meta: {
      title: 'Work — Nathan Lecompte',
      metaTags: [
        {
          name: 'description',
          content: 'A list of some of the most recent personal and professional work by Nathan Lecompte in no particular order.'
        },
        {
          name: 'keywords',
          content: 'nathan,lecompte,natlec,tech,enthusiast,programmer,developer,designer,work,projects,personal,professional,recent,ncea,techviewforum,techviewhd,moondrop'
        },
        {
          property: 'og:title',
          content: 'Work — Nathan Lecompte'
        },
        {
          property: 'og:description',
          content: 'A list of some of the most recent personal and professional work by Nathan Lecompte in no particular order.'
        }
      ]
    }
  },
  {
    path: '/work/:id/:url',
    name: 'work-post',
    component: WorkPost
  },
  {
    path: '/work/*',
    redirect: '/work'
  },
  {
    path: '/credits',
    name: 'credits',
    component: Credits,
    meta: {
      title: 'Credits — Nathan Lecompte',
      metaTags: [
        {
          name: 'description',
          content: 'Legal jargon which credits all third-party content utilised by this website; for legal and honorary reasons.'
        },
        {
          name: 'keywords',
          content: 'nathan,lecompte,natlec,tech,enthusiast,programmer,developer,designer,work,credits,legal,sansforgetica,rmit,openpgpjs,licenses'
        },
        {
          property: 'og:title',
          content: 'Credits — Nathan Lecompte'
        },
        {
          property: 'og:description',
          content: 'Legal jargon which credits all third-party content utilised by this website; for legal and honorary reasons.'
        }
      ]
    }
  },
  {
    path: '/sitemap',
    name: 'sitemap',
    component: Sitemap,
    meta: {
      title: 'Sitemap — Nathan Lecompte',
      metaTags: [
        {
          name: 'description',
          content: 'Sitemap of every internal link on this website in order of importance; not particularly interesting in terms of content.'
        },
        {
          name: 'keywords',
          content: 'nathan,lecompte,natlec,tech,enthusiast,programmer,developer,designer,work,sitemap'
        },
        {
          property: 'og:title',
          content: 'Sitemap — Nathan Lecompte'
        },
        {
          property: 'og:description',
          content: 'Sitemap of every internal link on this website in order of importance; not particularly interesting in terms of content.'
        }
      ]
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy,
    meta: {
      title: 'Privacy — Nathan Lecompte',
      metaTags: [
        {
          name: 'description',
          content: 'Privacy policy outlining the information collection practices of this website; may be of interest to the privacy-conscious.'
        },
        {
          name: 'keywords',
          content: 'nathan,lecompte,natlec,tech,enthusiast,programmer,developer,designer,work,privacy,cookies,personal,information'
        },
        {
          property: 'og:title',
          content: 'Privacy — Nathan Lecompte'
        },
        {
          property: 'og:description',
          content: 'Privacy policy outlining the information collection practices of this website; may be of interest to the privacy-conscious.'
        }
      ]
    }
  },
  {
    path: '*',
    component: Error,
    meta: {
      title: 'Error'
    }
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  routes
})

// Add page-specific meta tags
router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)

  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)

  if (nearestWithTitle) document.title = nearestWithTitle.meta.title

  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

  if (!nearestWithMeta) return next()

  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta')

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key])
    })

    tag.setAttribute('data-vue-router-controlled', '')

    return tag
  }).forEach(tag => document.head.appendChild(tag))

  next()
})

export default router
